import component from './roiFunnel.vue'

export default component
